<script setup>
import { Link } from '@inertiajs/vue3'
import { BellIcon } from '@heroicons/vue/24/outline'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { user_image } from '@/helpers'
import Mascot from '@/Components/Mascot.vue'
</script>

<template>
  <Popover v-slot="{ open, close }" class="relative">
    <PopoverButton
      :class="open ? '' : 'text-opacity-90'"
      class="!focus:outline-none group inline-flex items-center rounded-md p-2 text-base font-medium text-white hover:text-opacity-100"
    >
      <div class="relative">
        <BellIcon class="size-7 stroke-zinc-500 sm:size-8" />

        <div
          v-if="$page.props.auth.user.notifications.length !== 0"
          class="absolute -right-0.5 -top-1 h-4 w-auto rounded-full bg-red-500 px-1 text-xs"
        >
          {{
            $page.props.auth.user.notifications.length > 9
              ? '+9'
              : $page.props.auth.user.notifications.length
          }}
        </div>
      </div>
    </PopoverButton>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <PopoverPanel
        class="fixed left-0 z-20 mt-2 w-screen sm:absolute sm:max-w-sm sm:-translate-x-3/4"
      >
        <div class="overflow-hidden rounded-b-sm bg-gray-50 shadow-lg ring-1 ring-black/5">
          <p class="prose-xs m-4 font-semibold">Notifications</p>

          <div
            v-if="$page.props.auth.user.notifications.length > 0"
            class="divide-y divide-stone-300"
          >
            <Link
              v-for="notification in $page.props.auth.user.notifications"
              :key="notification.id"
              :href="route('account.notifications.read', { notification: notification.id })"
              rel="nofollow"
              method="post"
              class="w-full cursor-pointer text-left text-xs text-gray-700 hover:bg-stone-200"
              @click="close"
            >
              <div class="p-2" :class="{ 'bg-stone-200': !notification.read_at }">
                <div class="flex space-x-2">
                  <Mascot
                    v-if="notification.type === 'global_announcement'"
                    class="h-12 w-auto rounded-full"
                  />
                  <img
                    v-else
                    :src="user_image(notification.image)"
                    :alt="notification.data.title"
                    class="size-12 rounded-full"
                  />

                  <div class="space-y-1">
                    <h3 class="font-bold">
                      {{ notification.data.title }}
                    </h3>

                    <div class="line-clamp-2">
                      {{ notification.data?.body }}
                    </div>

                    <time class="block text-xs text-gray-400">
                      {{ notification.notified_at }}
                    </time>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div v-else class="p-4 text-center text-sm text-gray-500">
            <p>No unread notifications</p>
          </div>

          <Link
            rel="nofollow"
            :href="route('account.notifications.show')"
            class="mx-auto flex justify-center p-4 text-sm font-medium text-primary transition hover:text-primary/80"
            @click="close"
          >
            All notifications
          </Link>
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>
